import { currentConfig, type Config, type Feature } from './domainConfig';

export type { Feature } from './domainConfig';

/**
 * Whether this deployment shows a fitness surface.
 *
 * The one gating point. Every surface that retail drops — composition, the
 * body fat target, weight, body fat itself — asks here rather than testing the
 * hostname, so a new product is a new row in domainConfig, not a new branch in
 * each component.
 */
export const hasFeature = (name: Feature, config: Pick<Config, 'features'> = currentConfig): boolean =>
  config.features[name];

/**
 * The same, for components. The config is fixed for the life of the page (a
 * host, or an override read once at load), so there is nothing to subscribe to.
 */
export const useFeature = (name: Feature): boolean => hasFeature(name);

/** What the person being measured is called, in the four forms the UI needs. */
export interface ProfileNoun {
  Client: string;
  client: string;
  Clients: string;
  clients: string;
}

export const profileNoun = (config: Pick<Config, 'strings'> = currentConfig): ProfileNoun => {
  const one = config.strings.profile;
  const many = `${one}s`;
  return {
    Client: one,
    client: one.toLowerCase(),
    Clients: many,
    clients: many.toLowerCase(),
  };
};

/** "Client" on fitness hosts, "Customer" on retail. */
export const noun: ProfileNoun = profileNoun();
